import React, { useContext, useEffect, useState } from 'react';
import { Select, Modal, Spin } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { PrimaryButton, DisabledButton, SecondaryButton } from '../../Commons';
import { StepContext } from '../../Commons/Context';
import StepContainer from '../../Components/StepContainer';
import { fetchWorkflowById } from '../../Http/workflow';
import { useDispatch, useSelector } from 'react-redux';
import { addLatestWorkflow, getLatestWorkflow } from '../../redux/slices/workflow/latestWorkflow';
import { Step } from '../../Http/models/Step.model';
import './style.scss'
const quickbooksEnvironments = [
	{
		envTitle:"Production Environment",
		envValue:"prod"
	},
	{
		envTitle:"Sandbox Environment",
		envValue:"sandbox"
	},
]

const QuickbooksChooseAccount = ({ authRequestFunction }) => {

	const dispatch = useDispatch();
	const latestWorkflow = useSelector(getLatestWorkflow);
	const { appName, appCode, accountAuthorized, next } = useContext(StepContext);
	const [isOpen, setIsOpen] = useState(false);
	const [qckbEnv, setQckbEnv] = useState('prod');
	const [step, setStep] = useState(new Step());
	const [spinning, setSpinning] = useState(false);


	useEffect(()=>{
		if(latestWorkflow.step1.appCode === appCode){
			setStep(latestWorkflow.step1);
		}else if(latestWorkflow.step2.appCode === appCode){
			setStep(latestWorkflow.step2);
		}
		console.log({step});
	},[accountAuthorized])


	const adjustLatestWorkflow = async () =>{
		setSpinning(true);
		const workflowRes = await fetchWorkflowById(latestWorkflow.workflowId);
		dispatch(addLatestWorkflow(workflowRes.data));
		setSpinning(false);
		if(latestWorkflow.step1.appCode === appCode){
			setStep(workflowRes.data.step1)
		}else if(latestWorkflow.step2.appCode === appCode){
			setStep(workflowRes.data.step2)
		}
		
		console.log({step});
	}

	const ButtonAuthorized = () => {
		return appCode === 'QCKB' ? (
			<SecondaryButton
				onClick={() => setIsOpen(true)}
				className='btn-long secondary-button-color'
				size='large'>
				<LockOutlined /> Authorized - Click to change environment
			</SecondaryButton>
		) : (
			<DisabledButton disabled className='btn-long secondary-button-color' size='large'>
				<LockOutlined /> Authorized
			</DisabledButton>
		);
	};
	const ButtonAddAccount = () => {
		let fn =
			appCode === 'QCKB' ? () => setIsOpen(true) : () => authRequestFunction(cb => {
				adjustLatestWorkflow();
			});
		return (
			<PrimaryButton className='btn-long primary-button-color' size='large' onClick={fn}>
				Add Account
			</PrimaryButton>
		);
	};
	const ButtonContinue = () => (
		<PrimaryButton className='btn-long primary-button-color' size='large' onClick={() => next()}>
			Continue
		</PrimaryButton>
	);
	const ChooseEnvironmentModal = () => {
	
		return (
			<Modal
				visible={isOpen}
				title='Choose Quickbooks Environment'
				onCancel={() => setIsOpen(false)}
				onOk={() => {
					authRequestFunction(qckbEnv, cb => adjustLatestWorkflow());
					setIsOpen(false);
				}}>
                <Select
					defaultValue={qckbEnv}
					onChange={(v) => setQckbEnv(v)}
					className='fill-width'>
					{
						quickbooksEnvironments?.map(env=>
							<Select.Option key={env.envValue} value={env.envValue}>
						       {env.envTitle}
							</Select.Option>
						)
					}
					
				</Select>
			</Modal>
		);
	};

	return (
		<StepContainer title='Choose Account'>
			{<Spin style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}} spinning={spinning} />}
			{`${appName ? appName : 'unknown'} Account: `}
			<span className='required'>(required)</span>
			{step.accountAuthorized ? <ButtonAuthorized /> : <ButtonAddAccount />}
			{step.accountAuthorized && <ButtonContinue />}
			{appCode === 'QCKB' && <ChooseEnvironmentModal />}
		</StepContainer>
	);
};

export default QuickbooksChooseAccount;
